// extracted by mini-css-extract-plugin
export default {"carousel":"iba","ingredient":"jba","swiper-pagination-bullet":"kba","swiper-pagination-bullet-active":"lba","swiper_carousel":"mba","swiper_pagination":"nba","arrows":"oba","arrow_navigation":"pba"};
    if(module.hot) {
      // 1738064244337
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  